import Selector from "./Selector";

import { SelectorValue as TSelectorValue } from "./Selector";
export type SelectorValue = TSelectorValue;

import { SelectorProps as TSelectorProps } from "./Selector";
export type SelectorProps<T> = TSelectorProps<T>;

export default Selector;
